import { Classes } from "@blueprintjs/core";
import { ReactNode } from "react";
import { PageHeaderStyled, PageHeaderRoot } from "./Styles";

export interface PageHeaderProps {
  title?: ReactNode;
  description?: ReactNode;
  content?: ReactNode;
  footer?: ReactNode;
}
export const PageHeader = ({
  title,
  description,
  content,
  footer,
}: PageHeaderProps) => {
  const showHeader = !!title || !!description || !!content;
  return (
    <PageHeaderRoot>
      {showHeader && (
        <PageHeaderStyled>
          <div>
            <h3 className={Classes.HEADING}>{title}</h3>
            <p>{description}</p>
          </div>
          <div>{content}</div>
        </PageHeaderStyled>
      )}
      {footer && <div className="pg-header-footer">{footer}</div>}
    </PageHeaderRoot>
  );
};
